export const mergedRecords = (existingData, updatedData) => {
  const taxMap = new Map();
  existingData.forEach((record) => taxMap.set(record.taxId, record));
  updatedData.forEach((update) => {
    if (taxMap.has(update.taxId)) {
      taxMap.set(update.taxId, { ...taxMap.get(update.taxId), ...update });
    } else {
      taxMap.set(update.taxId, update);
    }
  });

  return Array.from(taxMap.values());
};

export default {};
